import { EventTypes, track, getPageSource } from '@mc/track-event'

export const trackViewClassInfoClick = ({
  classSlug,
  categorySlug,
  link,
  uuid,
}: {
  classSlug: string
  categorySlug?: string
  link: string
  uuid: string
}) => {
  track(EventTypes.CATALOG_PAGE_CLICK, {
    action: 'View Class Info',
    category: categorySlug,
    uuid,
    class: classSlug,
    link,
    location: 'video_playlist_module_sample',
    page_path: window.location.pathname,
    page_source: getPageSource(),
    type: 'all-access-pass',
  })
}

export const trackShareButtonClick = ({
  classSlug,
  categorySlug,
  uuid,
}: {
  classSlug: string
  categorySlug: string
  uuid: string
}) => {
  track(EventTypes.CATALOG_PAGE_CLICK, {
    action: 'Share',
    uuid,
    class: classSlug,
    location: 'video_playlist_module_sample',
    page_source: getPageSource(),
    category: categorySlug,
  })
}
